import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoheaderService } from 'src/app/services/poheader.service';
import { PO_HEADER } from 'src/app/model/PO_HEADER.model';
import { POLine } from 'src/app/model/po-line.model';
import { ToastrService } from 'ngx-toastr';
import { PaginationInstance } from 'ngx-pagination';
import { CreditMemoService } from 'src/app/services/credit-memo.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from 'src/app/services/notification.service';
import { VMS_Notification } from 'src/app/model/notification.model';
import * as XLSX from 'xlsx'; 
import { FilterModel } from 'src/app/model/filter.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  filterModel:FilterModel;
  p: any;
  PoheaderModel: PO_HEADER;
  PoheaderList: PO_HEADER[] = [];
  PoLineModel: POLine;
  PoLineList: POLine[] = [];
  TempPoHeaderList: PO_HEADER[] = [];
  CountDraftPI: number = 0;
  CountAllPI: number = 0;
  CountSubmittedPI: number = 0;
  CountPendingApprovalPI: number = 0;
  CountPostedInvoicePI: number = 0;
  CountApprovedPI: number = 0;
  CountRejectedByCustPI: number = 0;

  CreditCountDraftPI: number = 0;
  CreditCountAllPI: number = 0;
  CreditCountSubmittedPI: number = 0;
  CreditCountPendingApprovalPI: number = 0;
  CreditCountPostedInvoicePI: number = 0;
  CreditCountApprovedPI: number = 0;
  CreditCountRejectedByCustPI: number = 0;

  NetTotal: number = 0;
  RemainingAmount: number;
  UserName: string = '';
  UserRole: string = '';
  searchTerm: any;
  ToggleDashboard: boolean = false;
  CreditMemoList: any[]=[];
  //userFilter: any = { PH_SUBMISSION_DATE: '' };
  IsAdmin:boolean = false;
  downloadBaseURL :string;
  Status:string='DRAFT';
  dataListStatus:string='No Record Found.';
  constructor(private router: Router, private POHeaderSer: PoheaderService,
    private toasterSer: ToastrService, private _creditMemo: CreditMemoService,
    private spinner: NgxSpinnerService,private notificationSer: NotificationService) { 

      this.downloadBaseURL = this.notificationSer.GetDownloadBaseURL();
      this.filterModel=new FilterModel();
    }


  ngOnInit() {

    let notice = sessionStorage.getItem("notice");
    console.log('notice', notice);
    if (notice == null || notice == '') { this.GetPageNotifications(2); }
    

    this.UserRole = sessionStorage.getItem("UserRole");
    this.UserName = sessionStorage.getItem("UserName");
    this.IsAdmin = (this.UserRole.toLowerCase() =='admin'? true:false);
   
    
    this.GetPOHeaderList();
    this.GetPOHeaderSummary();

    // this.GetCreditMemoList();
    // this.GetCreditMemoSummary();
    //this.GetAllCreditMemo();
  }
  ViewPayInfo(InvoiceNo: any) {
    this.router.navigate(['/paymentinformation'], { queryParams: { InvoiceNo: InvoiceNo }, replaceUrl: true });
  }
  NavPurInvoiceNo(InvoiceNo: any) {
    this.router.navigate(['/createpurchaseorder'], { queryParams: { PurInvoiceNo: InvoiceNo }, replaceUrl: true });
  }

  DeletePIRecord(PurchaseInvoiceNo: any) {

    debugger;
    if (confirm('Do you want to delete Purchase Invoice')) {
      this.POHeaderSer.DeletePurchaseInvoice(PurchaseInvoiceNo).subscribe(
        res => {
          if (res.Status) {
            this.toasterSer.success('Purchase invoice has been deleted successfully!!!');
            this.GetPOHeaderList();
          }
          else {
            this.toasterSer.error(res.Message);
          }
        },
        error => {
          console.log(error);
          console.error();
        }
      );
    }
  }

  DeleteCreditNoteRecord(CreditNoteNo: any) {

    debugger;
    if (confirm('Do you want to delete this ?')) {
      this.POHeaderSer.DeleteCreditMemoDetails(CreditNoteNo).subscribe(
        res => {
          if (res.Status) {
            console.log(res);
            this.toasterSer.success('Credit Note has been deleted successfully!!!');
            this.GetAllCreditMemo();
          }
          else {
            this.toasterSer.error(res.Message);
          }
        },
        error => {
          console.log(error);
          console.error();
        }
      );
    }
  }

  stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
  }
  // List of ALL PO 

  GetPOHeaderList(status='DRAFT') {
    this.dataListStatus='Loading...';
    this.Status = status;
    this.PoheaderList=[];
    this.TempPoHeaderList=[];
    this.POHeaderSer.GetAllPurchaseInvoice(this.UserRole.toLocaleLowerCase(),this.UserName,status).subscribe(
      res => {
        debugger;
        console.log(res);
        if(res.Status)
        {
          this.PoheaderList = res.Data;
          this.TempPoHeaderList = res.Data;
        }
        this.dataListStatus='No Record Found.';

        // if (this.UserRole.toLocaleLowerCase() == "admin") {
        //   this.TempPoHeaderList = res.Data;
        //   this.PoheaderList = res.Data;
        // }
        // else {
        //   this.TempPoHeaderList = res.Data;
        //   this.TempPoHeaderList.sort(x => x.PH_PURCHASE_INVOICE_NO);
        //   this.TempPoHeaderList = this.TempPoHeaderList.filter(x => x.PH_CREATED_BY == this.UserName);
        //   this.PoheaderList = res.Data;
        //   this.PoheaderList = this.PoheaderList.filter(x => x.PH_CREATED_BY == this.UserName);
        // }

        //debugger;

        // this.PoheaderList = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'DRAFT');
        // this.CountDraftPI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'DRAFT').length;
        // this.CountSubmittedPI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'SUBMITTED').length;
        // this.CountPendingApprovalPI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'PENDING APPROVAL').length;
        // this.CountPostedInvoicePI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'POSTED INVOICE').length;
        // this.CountRejectedByCustPI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'REJECTED BY CUSTOMER').length;
        // this.CountApprovedPI = this.TempPoHeaderList.filter(x => x.PH_STATUS == 'APPROVED').length;
        // this.CountAllPI = this.TempPoHeaderList.length;
        // this.PoheaderList.forEach(element => {
        //   var TotalGSTAmount = element.purchase_LineModels.reduce((sum, current) => sum + current.PL_GST_AMOUNT, 0);
        //   //var TotalBaseAmount= element.purchase_LineModels.reduce((sum, current) => sum + current.PL_GST_BASE_AMT, 0);

        //   var TotalLineAmount = element.purchase_LineModels.reduce((sum, current) => sum + current.PL_LINE_AMOUNT, 0);
        //   //element.PH_VENDOR_INVOICE_AMT= Number((TotalGSTAmount+TotalBaseAmount).toFixed(2));
        //   element.PH_VENDOR_INVOICE_AMT = Number((TotalGSTAmount + TotalLineAmount).toFixed(2));
        //   element.RemainingAmount = Number((element.PH_VENDOR_INVOICE_AMT - element.TotalPostedInvoiceAmount).toFixed(2));
        // });

      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  POSummary:any[]=[];
  GetPOHeaderSummary() {


    this.POHeaderSer.GetPurchaseInvoiceSummary(this.UserRole.toLocaleLowerCase(), this.UserName).subscribe(
      res => {
        debugger;
        console.log(res);
        this.POSummary = res.Data;

        this.CountDraftPI = this.FindPOStatusCount(this.POSummary, 'DRAFT');
        this.CountSubmittedPI = this.FindPOStatusCount(this.POSummary, 'SUBMITTED');
        this.CountPendingApprovalPI = this.FindPOStatusCount(this.POSummary, 'PENDING APPROVAL');
        this.CountPostedInvoicePI = this.FindPOStatusCount(this.POSummary, 'POSTED INVOICE');
        this.CountRejectedByCustPI = this.FindPOStatusCount(this.POSummary, 'REJECTED BY CUSTOMER');
        this.CountApprovedPI = this.FindPOStatusCount(this.POSummary, 'APPROVED');

        // this.CountDraftPI = this.POSummary.filter(x => x.PH_STATUS == 'DRAFT')[0]["DATA_COUNT"];
        // this.CountSubmittedPI = this.POSummary.filter(x => x.PH_STATUS == 'SUBMITTED')[0]["DATA_COUNT"];
        // this.CountPendingApprovalPI = this.POSummary.filter(x => x.PH_STATUS == 'PENDING APPROVAL')[0]["DATA_COUNT"];
        // this.CountPostedInvoicePI = this.POSummary.filter(x => x.PH_STATUS == 'POSTED INVOICE')[0]["DATA_COUNT"];
        // this.CountRejectedByCustPI = this.POSummary.filter(x => x.PH_STATUS == 'REJECTED BY CUSTOMER')[0]["DATA_COUNT"];
        // this.CountApprovedPI = this.POSummary.filter(x => x.PH_STATUS == 'APPROVED')[0]["DATA_COUNT"];
        this.CountAllPI = this.CountDraftPI + this.CountSubmittedPI + this.CountPendingApprovalPI +
          this.CountPostedInvoicePI + this.CountRejectedByCustPI + this.CountApprovedPI;


      },
      error => {
        console.log(error);
      }
    );
  }

  FindPOStatusCount(datalist = [], status) {
    if (datalist.length > 0) {
      var data = datalist.find(x => x.PH_STATUS == status);
      if (data != undefined && data != null) {
        return data["DATA_COUNT"];
      }
      else {
        return 0;
      }
    }
    else {
      return 0;
    }
  }

  FindCreditMemoStatusCount(datalist = [], status) {
    if (datalist.length > 0) {
      var data = datalist.find(x => x.Status == status);
      if (data != undefined && data != null) {
        return data["DATA_COUNT"];
      }
      else {
        return 0;
      }
    }
    else {
      return 0;
    }
  }


  GetCreditMemoList(status='DRAFT') {
    this.Status = status;
    this.spinner.show();
    this.PoheaderList=[];
    this.TempCreditMemoList = [];
   
    this.POHeaderSer.GetDashboardCreditMemoDetails(this.UserRole.toLocaleLowerCase(),this.UserName,status).subscribe(
      res => {
        debugger;
        console.log('CreditMemoList', res);
        //alert(res);
        this.CreditMemoList = res.Data;
        this.TempCreditMemoList = res.Data;
        this.spinner.hide();
      },
      error => {
        console.log(error);
     
        console.error();
        this.spinner.hide();
      }
    );
  }

  CMSummary:any[]=[];
  GetCreditMemoSummary() {

    this.POHeaderSer.GetDashboardCreditMemoSummary(this.UserRole.toLocaleLowerCase(),this.UserName).subscribe(
      res => {
        debugger;
        console.log(res);
        this.CMSummary = res.Data;
        //alert(this.CMSummary);

        this.CreditCountDraftPI = res.Data.DRAFT;
        this.CreditCountSubmittedPI = res.Data.SUBMITTED;
        this.CreditCountPendingApprovalPI = res.Data.PENDINGAPPROVAL;
        this.CreditCountPostedInvoicePI = res.Data.POSTEDINVOICE;
        this.CreditCountRejectedByCustPI = res.Data.REJECTEDBYCUSTOMER;
        this.CreditCountApprovedPI = res.Data.APPROVED;
        this.CreditCountAllPI =res.Data.DRAFT+res.Data.SUBMITTED+res.Data.PENDINGAPPROVAL+res.Data.POSTEDINVOICE+res.Data.REJECTEDBYCUSTOMER+res.Data.APPROVED;

        // this.CreditCountDraftPI = this.FindCreditMemoStatusCount(this.CMSummary, 'DRAFT');
        // this.CreditCountSubmittedPI = this.FindCreditMemoStatusCount(this.CMSummary, 'SUBMITTED');
        // this.CreditCountPendingApprovalPI = this.FindCreditMemoStatusCount(this.CMSummary, 'PENDING APPROVAL');
        // this.CreditCountPostedInvoicePI = this.FindCreditMemoStatusCount(this.CMSummary, 'POSTED INVOICE');
        // this.CreditCountRejectedByCustPI = this.FindCreditMemoStatusCount(this.CMSummary, 'REJECTED BY CUSTOMER');
        // this.CreditCountApprovedPI = this.FindCreditMemoStatusCount(this.CMSummary, 'APPROVED');



        // this.CreditCountDraftPI = this.CMSummary.filter(x => x.Status == 'DRAFT')[0]["DATA_COUNT"];
        // this.CreditCountSubmittedPI = this.CMSummary.filter(x => x.Status == 'SUBMITTED')[0]["DATA_COUNT"];
        // this.CreditCountPendingApprovalPI = this.CMSummary.filter(x => x.Status == 'PENDING APPROVAL')[0]["DATA_COUNT"];
        // this.CreditCountPostedInvoicePI = this.CMSummary.filter(x => x.Status == 'POSTED INVOICE')[0]["DATA_COUNT"];
        // this.CreditCountRejectedByCustPI = this.CMSummary.filter(x => x.Status == 'REJECTED BY CUSTOMER')[0]["DATA_COUNT"];
        // this.CreditCountApprovedPI = this.CMSummary.filter(x => x.Status == 'APPROVED')[0]["DATA_COUNT"];

        //this.CreditCountAllPI =this.CreditCountDraftPI+this.CreditCountSubmittedPI+this.CreditCountPendingApprovalPI+
        //this.CreditCountPostedInvoicePI+this.CreditCountRejectedByCustPI+ this.CreditCountApprovedPI;

alert

      },
      error => {
        console.log(error);
      }
    );
  }

  ResetPage() {
    this.p = 1;
  }


  FilterPIList(Status: any) {
    if (Status == 'ALL') {
      this.PoheaderList = this.TempPoHeaderList;

    } else {
      this.PoheaderList = this.TempPoHeaderList.filter(x => x.PH_STATUS == Status);
    }

  }

  FilterCrMemoList(Status: any) {
    if (Status == 'ALL') {
      this.CreditMemoList = this.TempCreditMemoList;

    }
    else if (Status == 'DRAFT') {
      this.CreditMemoList = this.TempCreditMemoList.filter(x => x.SubmittedFlag == false && x.DraftFlag == true && x.Status.toLowerCase() == 'open');
    }

    else if (Status == 'POSTED INVOICE') {
      this.CreditMemoList = this.TempCreditMemoList.filter(x => x.PostedInvoiceFlag == true);

    }
    else if (Status == 'SUBMITTED') {
      this.CreditMemoList = this.TempCreditMemoList.filter(x => x.SubmittedFlag == true && x.DraftFlag == true && x.Status.toLowerCase() == 'open');

    }
    else {
      this.CreditMemoList = this.TempCreditMemoList.filter(x => x.Status.toLowerCase() == Status.toLowerCase());
    }

  }

  DownLoadUserManual() {
    window.open("/assets/Vendor Invoicing Management System-Manual_Final.pdf");
    //window.location.href="/assets/Vendor Invoicing Management System-Manual_Final.pdf";

  }

  nav() {
    this.router.navigate(['/paymentinformation'], { replaceUrl: true });
  }

  // Start Code for List of All Credit Memo-20/05/2021


  TempCreditMemoList: any[]=[];
  GetAllCreditMemo() {
    var VendorNo = this.UserName;
    if (this.UserRole.toLocaleLowerCase() == "admin") {
      VendorNo = "";
    }

    this.POHeaderSer.GetAllCreditMemo(VendorNo, "").subscribe(
      res => {
        debugger;
        res.Data.forEach(element => {
          element.InvoiceDate = element.InvoiceDate.split(' ')[0];

        });
        this.TempCreditMemoList = res.Data;
        this.CreditMemoList = res.Data.filter(x => x.DraftFlag == true && x.SubmittedFlag == false && x.Status.toLowerCase() == 'open');
        this.CreditCountDraftPI = this.TempCreditMemoList.filter(x => x.DraftFlag == true && x.SubmittedFlag == false && x.Status.toLowerCase() == 'open').length;
        this.CreditCountSubmittedPI = this.TempCreditMemoList.filter(x => x.SubmittedFlag == true && x.DraftFlag == true && x.Status.toLowerCase() == 'open').length
        this.CreditCountPendingApprovalPI = this.TempCreditMemoList.filter(x => x.Status.toLowerCase() == 'send to support').length
        this.CreditCountPostedInvoicePI = this.TempCreditMemoList.filter(x => x.PostedInvoiceFlag == true).length
        this.CreditCountRejectedByCustPI = this.TempCreditMemoList.filter(x => x.Rejected == true).length
        this.CreditCountApprovedPI = this.TempCreditMemoList.filter(x => x.Status.toLowerCase() == 'approved').length
        this.CreditCountAllPI = this.TempCreditMemoList.length;

        //.filter(x=>x.VendNo.toLowerCase()==this.UserName.toLowerCase());  

      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }
  ViewCreditPayInfo(InvoiceNo: any) {
    this.router.navigate(['/salescreditnote'], { queryParams: { CreditMemoNo: InvoiceNo }, replaceUrl: true });
  }
  // End Code for List of All Credit Memo-20/05/2021



  ToggleDashboardChnage()
  {
    this.filterModel = new FilterModel();

    if(this.ToggleDashboard)
    {
      this.GetCreditMemoList();
      this.GetCreditMemoSummary();
    }
    else
    {
      this.GetPOHeaderList();
      this.GetPOHeaderSummary();
    }


    // if(!this.ToggleDashboard)
    // {
    //   this.GetPOHeaderList();
    //   this.GetPOHeaderSummary();
    // }
  }


  formattedDate(d:any) {

    d = new Date(d);
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }


  closeNotice()
  {
    sessionStorage.setItem("notice","1");
  }

  notificationList: VMS_Notification[] = [];
  GetPageNotifications(pageId: number) {
    this.notificationSer.GetPageNotifications(0,pageId).subscribe(
      res => {
        console.log('PageNotifications',res);
        this.notificationList = res.Data;
        if(this.notificationList.length>0){document.getElementById('btnNotice').click();}
          
      },
      error => {
        console.log(error);
      }
    );
  }

  CheckAttachmentName(attachName): string {

    if (attachName == '' || attachName == undefined || attachName == null) {
      return '';
    }
    else {
      let li = attachName.indexOf('.');
      let fname = attachName.substring(0, (li - 15));
      const pattern = /_/gi;
      const replacement = " ";
      return fname;
      // return fname.replace(pattern, replacement);
    }
  }

// 04-11-2023


  exportexcel(tableId, filename): void {

    debugger;
    /* table id is passed over here */
    let element = document.getElementById(tableId);

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename+'.xlsx');
  }

  ConvertToDate(d:any) {

    d = new Date(d);
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${year}-${month}-${day}`;
  }

  FilterData() {
    debugger;
    console.log('FilterData', this.filterModel);

    if (this.filterModel.START_DATE == null || this.filterModel.START_DATE == undefined || this.filterModel.START_DATE.toString() =='') {
      this.toasterSer.warning("Please Enter Start Date.", "Error");
      return;
    }
    else if (this.filterModel.END_DATE == null || this.filterModel.END_DATE == undefined || this.filterModel.START_DATE.toString() =='') {
      this.toasterSer.warning("Please Enter End Date.", "Error");
      return;
    }
    else if (new Date(this.filterModel.END_DATE) < new Date(this.filterModel.START_DATE)) {
      this.toasterSer.warning("End Date should be greater than Start Date ", "Error");
      return;
    }

    if (this.ToggleDashboard) {
      this.CreditMemoList = this.TempCreditMemoList.filter(x => {
        let subDate = this.ConvertToDate(x.PostingDate);
        if (new Date(subDate) >= new Date(this.filterModel.START_DATE)
          && new Date(subDate) <= new Date(this.filterModel.END_DATE))
          return x;
      });
      console.log('CreditMemoList-Date', this.CreditMemoList);
    }
    else
    {
      this.PoheaderList = this.TempPoHeaderList.filter(x => {
        let subDate = this.Status=='DRAFT'? this.ConvertToDate(x.PH_CREATED_ON) : this.ConvertToDate(x.PH_SUBMISSION_DATE);

        if (new Date(subDate) >= new Date(this.filterModel.START_DATE)
          && new Date(subDate) <= new Date(this.filterModel.END_DATE))
          return x;
      });

      console.log('PoheaderList-Date', this.PoheaderList);
    } 
  }

  ResetFilterData()
  {
    this.PoheaderList = this.TempPoHeaderList;
    this.CreditMemoList = this.TempCreditMemoList;
    this.filterModel =new FilterModel();
  }


  
}



